exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".technical-support-page {\n  width: 80%;\n  margin: auto;\n  font-size: 16px;\n  padding: 30px;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/TechnicalSupportPage/technicalSupportPage.scss
// module id = 2456
// module chunks = 0